export enum CompanyCainLamarrePrivacyPolicy {
  EN_PRIVACY_POLICY = 'https://cainlamarre.ca/en/terms-of-use-and-privacy-policy/',
  FR_PRIVACY_POLICY = 'https://cainlamarre.ca/politique-confidentialite/'
}
